import { render, staticRenderFns } from "./PackageHeader.vue?vue&type=template&id=59e132fe&scoped=true&"
import script from "./PackageHeader.vue?vue&type=script&lang=ts&"
export * from "./PackageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PackageHeader.vue?vue&type=style&index=0&id=59e132fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e132fe",
  null
  
)

export default component.exports